import { Immutable } from "immer";
import React, { type JSX } from "react";

import { IMenuCategoryLink, IMenuItem } from "../../utils/menu.interface";
import { CategoryLink } from "./main-menu-category-link";
import { DropdownLinks } from "./main-menu-dropdown-links";
import { PageLink } from "./main-menu-page-link";

type IProps = Immutable<{
    cmsData: IMenuItem[];
    isMobile: boolean;
    modalIsOpen: boolean;
}> & {
    openModal: (event: React.MouseEvent<HTMLElement>) => void;
    closeModal: (event: React.MouseEvent<HTMLElement>) => void;
};

export const MenuLinks = (props: IProps): React.ReactNode => {
    const buildCategoryLinks = (menuItem: Immutable<IMenuCategoryLink>) => {
        const links: JSX.Element[] = [];
        let index = 0;
        let key = 0;

        const link = (
            <CategoryLink
                isMobile={props.isMobile}
                modalIsOpen={props.modalIsOpen}
                linkObject={menuItem}
                openModal={props.openModal}
                key={menuItem.value.title}
            />
        );
        links.push(link);

        if (!props.isMobile || menuItem.value.sub_nav.length <= 0) {
            return links;
        }

        // Build out Dropdown nav links (if they exist)
        const dropdownLinks = menuItem.value.sub_nav.filter((val) => {
            return val.type === "snippet_link_with_image";
        });

        if (dropdownLinks.length <= 0) {
            return links;
        }

        return links.concat(
            <DropdownLinks
                linksArray={dropdownLinks}
                linkID={index++}
                key={key++}
            />,
        );
    };

    let index = 0;
    const menuLinks = props.cmsData.reduce<JSX.Element[]>((memo, menuItem) => {
        switch (menuItem.type) {
            case "nav_category":
                return memo.concat(buildCategoryLinks(menuItem));
            case "page_link":
                return memo.concat(
                    <PageLink
                        linkObject={menuItem}
                        isMobile={props.isMobile}
                        linkID={index++}
                        key={menuItem.value.override_title}
                    />,
                );
        }
        return memo;
    }, []);
    return <div>{menuLinks}</div>;
};
